<template>
    <div>
        <HeaderStock header="จัดการข้อมูลวัตถุดิบ" :img_header="header_image" link_back="stock" />
        <StockMaterialList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock2.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import StockMaterialList from '@/components/menuadmin/stock/stockmaterial/StockMaterialList.vue'
export default {
    name:'stockMaterial',
    components:{
        HeaderStock,
        StockMaterialList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>